if (typeof ProductVariants !== "function") {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.price = document.querySelector(`#product-price-${this.dataset.id}`);

      if (this.price) {
        this.priceOriginal = this.price.querySelector("[data-js-product-price-original]");
        this.priceCompare = this.price.querySelector("[data-js-product-price-compare]");
        this.priceUnit = this.price.querySelector("[data-js-product-price-unit]");
      }

      this.productForm = document.querySelector(`#product-form-${this.dataset.id}`);

      if (this.productForm) {
        this.productQty = this.productForm.querySelector("[data-js-product-quantity]");
        this.addToCart = this.productForm.querySelector("[data-js-product-add-to-cart]");
        this.addToCartText = this.productForm.querySelector("[data-js-product-add-to-cart-text]");
      }

      this.addEventListener("change", this.onVariantChange);
      let initVariantChange = false;

      if (this.hasAttribute("data-variant-required")) {
        this.variantRequired = true;
        this.noVariantSelectedYet = true;
        if (document.location.search.includes("variant")) {
          const initVariant = parseInt(new URLSearchParams(document.location.search).get("variant"));
          this.currentVariant = this.getVariantData().find((variant) => {
            if (variant.id == initVariant) {
              variant.options.map((option, index) => {
                const variantContainer = this.querySelectorAll(`[data-js-product-variant]`)[index].querySelector(
                  `[data-js-product-variant-container]`
                );
                if (variantContainer.dataset.jsProductVariantContainer == "radio") {
                  variantContainer.querySelector(`input[value="${option}"]`).checked = true;
                } else if (variantContainer.dataset.jsProductVariantContainer == "select") {
                  variantContainer.value = option;
                }
              });
              return variant;
            }
          });

          if (this.currentVariant) {
            this.variantRequired = false;
            this.noVariantSelectedYet = false;
            this.classList.add("variant-selected");
            initVariantChange = true;
          }
        }
      } else {
        this.variantRequired = false;
        this.noVariantSelectedYet = false;
        this.classList.add("variant-selected");
      }

      this.updateOptions();
      this.updateMasterId();
      this.updateUnavailableVariants();

      this.productStock = document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity]`);
      this.productStockProgress = document.querySelector(
        `#product-${this.dataset.id} [data-js-variant-quantity-progress]`
      );
      if (this.productStock && document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`)) {
        this.productStockData = JSON.parse(
          document.querySelector(`#product-${this.dataset.id} [data-js-variant-quantity-data]`).dataset.inventory
        );
      }
      this.updateStock();

      this._event = new Event("VARIANT_CHANGE");

      if (initVariantChange) {
        this.onVariantChange();
      }
      document.dispatchEvent(new CustomEvent("INIT_VARIANT_CHANGE"));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantInput();
      if (this.price) {
        this.updatePrice();
      }
      this.updateStock();
      this.updateUnavailableVariants();
      this.updatePickupAvailability();
      if (!this.hasAttribute("data-no-history")) {
        this.updateURL();
      }
      this.updateDetails();

      if (this.productForm) {
        if (this.productQty) this.productQty.style.display = this.productQty ? "" : "none";

        if (this?.currentVariant?.available) {
          this.addToCart.classList.remove("hidden");
          this.productForm.classList.remove("unavailable-variant");
        } else {
          this.addToCart.classList.add("hidden");
          this.productForm.classList.add("unavailable-variant");
        }

        if (!this.currentVariant) {
          this.addToCartText.textContent =
            this.variantRequired && this.noVariantSelectedYet
              ? KROWN.settings.locales.products_variant_required
              : KROWN.settings.locales.products_unavailable_variant;
        } else {
          this.addToCartText.textContent = this.hasAttribute("data-show-bundle-wording")
            ? KROWN.settings.locales.products_add_to_bundle_button
            : this.addToCartText.hasAttribute("data-show-preorder-wording")
            ? KROWN.settings.locales.products_preorder_button
            : KROWN.settings.locales.products_add_to_cart_button;
        }
      }
      this.dispatchEvent(this._event);
    }

    updateOptions() {
      this.options = [];

      this.querySelectorAll("[data-js-product-variant-container]").forEach((elm) => {
        if (elm.dataset.jsProductVariantContainer == "radio") {
          elm.querySelectorAll(".product-variant__input").forEach((el) => {
            if (el.checked) {
              this.options.push(el.value);
            }
          });
        } else {
          if (!(this.variantRequired && elm.selectedIndex == 0)) {
            this.options.push(elm.value);
          }
        }
      });

      if (this.variantRequired && this.noVariantSelectedYet && this.options.length >= parseInt(this.dataset.variants)) {
        this.noVariantSelectedYet = false;
        this.classList.add("variant-selected");
      }
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updatePrice() {
      if (!this.currentVariant) {
        if (!(this.variantRequired && this.noVariantSelectedYet)) {
          this.priceOriginal.innerHTML = "";
          this.priceCompare.innerHTML = "";
          this.priceUnit.innerHTML = "";
        }
      } else {
        this.priceOriginal.innerHTML = this._formatMoney(this.currentVariant.price, KROWN.settings.shop_money_format);
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          this.priceCompare.innerHTML = this._formatMoney(
            this.currentVariant.compare_at_price,
            KROWN.settings.shop_money_format
          );
        } else {
          this.priceCompare.innerHTML = "";
        }

        if (this.currentVariant.unit_price_measurement) {
          this.priceUnit.innerHTML = `
						${this._formatMoney(this.currentVariant.unit_price, KROWN.settings.shop_money_format)} / 
						${
              this.currentVariant.unit_price_measurement.reference_value != 1
                ? this.currentVariant.unit_price_measurement.reference_value + " "
                : ""
            }
						${this.currentVariant.unit_price_measurement.reference_unit}
					`;
        } else {
          this.priceUnit.innerHTML = "";
        }
      }
    }

    updateStock() {
      if (!this.currentVariant) {
        if (this.productStock) {
          this.productStock.innerHTML = "";
        }
      } else {
        if (this.productStock && this.productStockData) {
          let currentVariant = false;
          for (const variant of this.productStockData) {
            if (variant.id == this.currentVariant.id) {
              currentVariant = variant;
              break;
            }
          }
          this.productStock.innerHTML = "";

          if (currentVariant) {
            if (currentVariant.quantity <= 0) {
              if (currentVariant.inventory == "continue") {
                this.productStock.innerHTML = KROWN.settings.locales.products_preorder;
                this.productStock.setAttribute("data-stock", "pre-order");
              } else if (currentVariant.inventory == "deny") {
                this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
                this.productStock.setAttribute("data-stock", "out-of-stock");
              }
            } else if (currentVariant.quantity == "1") {
              this.productStock.innerHTML = KROWN.settings.locales.products_one_product;
              this.productStock.setAttribute("data-stock", "one-item-stock");
            } else if (currentVariant.quantity <= parseInt(this.productStock.dataset.lowStock)) {
              this.productStock.innerHTML = KROWN.settings.locales.products_few_products.replace(
                "{{ count }}",
                currentVariant.quantity
              );
              this.productStock.setAttribute("data-stock", "little-stock");
            } else if (currentVariant.unavailable) {
              this.productStock.innerHTML = KROWN.settings.locales.products_no_products;
              this.productStock.setAttribute("data-stock", "out-of-stock");
            } else if (
              currentVariant.quantity > parseInt(this.productStock.dataset.lowStock) &&
              this.productStock.dataset.type == "always"
            ) {
              this.productStock.innerHTML = KROWN.settings.locales.products_many_products.replace(
                "{{ count }}",
                currentVariant.quantity
              );
              this.productStock.setAttribute("data-stock", "in-stock");
            } else if (!currentVariant.quantity && this.productStock.dataset.type == "always") {
              this.productStock.innerHTML = KROWN.settings.locales.products_enough_products;
              this.productStock.setAttribute("data-stock", "in-stock");
            }

            if (this.productStockProgress) {
              let progressQty = 0;
              if (
                (currentVariant.quantity <= 0 && currentVariant.inventory == "continue") ||
                typeof currentVariant.quantity === "undefined"
              ) {
                progressQty = parseInt(this.productStock.dataset.highStock);
              } else if (currentVariant.quantity > 0) {
                progressQty = currentVariant.quantity;
              }
              if (progressQty >= parseInt(this.productStock.dataset.highStock)) {
                this.productStockProgress.style.width = `100%`;
              } else {
                this.productStockProgress.style.width = `${
                  (100 * progressQty) / parseInt(this.productStock.dataset.highStock)
                }%`;
              }
            }
          }
        }
      }
    }

    updateDetails() {
      document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-sku]`).forEach((elm) => {
        if (this.currentVariant && this.currentVariant.sku) {
          elm.innerHTML = KROWN.settings.locales.product_sku + this.currentVariant.sku;
        } else {
          elm.innerHTML = "";
        }
      });

      document.querySelectorAll(`#product-${this.dataset.id} [data-js-product-barcode]`).forEach((elm) => {
        if (this.currentVariant && this.currentVariant.barcode) {
          elm.innerHTML = KROWN.settings.locales.product_barcode + this.currentVariant.barcode;
        } else {
          elm.innerHTML = "";
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector("pickup-availability");
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    updateUnavailableVariants() {
      if (this.dataset.hideVariants != "false") {
        if (this.dataset.variants == "1") {
          this.variantData.forEach((variant) => {
            if (!variant.available) {
              const input = this.querySelector(
                `[data-js-product-variant-container] .product-variant-value[value="${variant.option1}"]`
              );
              if (this.dataset.hideVariants == "disable") {
                input.setAttribute("disabled", "disabled");
              } else if (this.dataset.hideVariants == "hide") {
                const variantItem = input.closest(".product-variant__item");
                if (variantItem) {
                  variantItem.style.display = "none";
                  input.style.display = "none";
                }
              } else {
                input.classList.add("disabled");
              }
            }
          });
        } else {
          if (this.querySelector(":checked")) {
            const selectedOptionOneVariants = this.variantData.filter(
              (variant) => this.querySelector(":checked").value === variant.option1
            );

            const inputWrappers = [...this.querySelectorAll("[data-js-product-variant]")];
            inputWrappers.forEach((option, index) => {
              if (index === 0) return;
              const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
              const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
              const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                .map((variantOption) => variantOption[`option${index + 1}`]);
              this.setInputAvailability(optionInputs, availableOptionInputsValue);
            });
          }
        }
      }
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
          if (this.dataset.hideVariants == "disable") {
            input.removeAttribute("disabled");
          } else {
            input.classList.remove("disabled");
            input.parentElement.classList.remove("hidden");
          }
        } else {
          if (this.dataset.hideVariants == "disable") {
            input.setAttribute("disabled", "disabled");
          } else if (this.dataset.hideVariants == "hide") {
            const variantItem = input.closest(".product-variant__item");
            if (variantItem) {
              variantItem.style.display = "none";
              input.style.display = "none";
            }
          } else {
            input.classList.add("disabled");
            input.parentElement.classList.add("hidden");
          }
        }
      });
    }

    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      if (!this.currentVariant) return;
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.id}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    _formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }

      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split(".");
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get("product-variants") == "undefined") {
    customElements.define("product-variants", ProductVariants);
  }
}

/* ---
	Product Form
--- */

if (typeof ProductForm !== "function") {
  let color;
  let customText;
  let selectedColor;
  let selectedFont;

  function splitTags(tagsString) {
    let normalizedString = tagsString[0].replace(/\|/g, ",");

    normalizedString = normalizedString.replace(/([a-z])([A-Z])/g, "$1,$2");

    const tagsArray = normalizedString.split(",").map((tag) => tag.trim());
    return tagsArray;
  }
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    connectedCallback() {
      // Elements
      const textInput = document.getElementById("personalisation-text-input");
      const overlayText = document.getElementById("overlay-text");
      const swatches = document.querySelectorAll(".swatch");

      // Set a default text
      const defaultText = "Your Initials";

      // Function to update the overlay text
      function updateOverlayText() {
        if (!overlayText) return;
        overlayText.textContent = textInput.value || defaultText;
      }

      // Update text as the user types
      textInput?.addEventListener("input", function () {
        updateOverlayText();
      });

      // Update text color when a swatch is clicked
      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          const color = swatch.getAttribute("data-hex");
          overlayText.style.color = color;
        });
      });

      // Update the character counter
      textInput?.addEventListener("input", function () {
        const charCounter = document.querySelector(".char-counter");
        charCounter.textContent = `${textInput.value.length}/6`;
      });

      textInput?.addEventListener("input", function () {
        const charCounterPen = document.querySelector(".char-counter-pen");
        charCounterPen.textContent = `${textInput.value.length}/3`;
      });

      // Initial setting to show the default text if input is empty
      updateOverlayText();

      this.stickyMobile = this.stickyMobile.bind(this);

      document.addEventListener("DOMContentLoaded", () => {
        this.swatchHandling();
        this.selectionHandling();
        this.updateFonts();

        const observer = new IntersectionObserver(this.stickyMobile, {
          rootMargin: "1000000000% 0px 0px 0px",
          threshold: 1.0,
        });
        observer.observe(this.parentElement);
      });

      const selectedColorElement = document.getElementById("selected-color");

      // Add click event listener to each swatch
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", () => {
          // Get the color name from the clicked swatch's data-color attribute
          color = swatch.getAttribute("data-color");
          // Update the selected color text
          selectedColorElement.textContent = color;
        });
      });
    }

    stickyMobile() {
      const { innerHeight } = window;
      const { bottom } = this.getBoundingClientRect();

      if (innerHeight > bottom) {
        this.classList.add("sticky");
      } else {
        this.classList.remove("sticky");
      }
    }

    swatchHandling() {
      const swatches = document.querySelectorAll(".swatch");
      const productImage = document.getElementById("product-image");

      swatches.forEach((swatch) => {
        swatch.addEventListener("click", function () {
          // Remove 'active' class from all swatches
          swatches.forEach((s) => s.classList.remove("active"));

          // Add 'active' class to the clicked swatch
          swatch.classList.add("active");

          // Change the product image based on the selected swatch
          const newImage = swatch.getAttribute("data-image");
          productImage.src = newImage;
        });
      });
    }

    selectionHandling() {
      const submitButton = document.getElementById("personalisation_add_to_cart");
      const colorSwatches = document.querySelectorAll(".color-swatches .swatch");
      const fontInputs = document.querySelectorAll(".color-swatches input");
      const customTextInput = document.getElementById("personalisation-text-input");

      let selectedColor = "";
      let selectedFont = "";
      let customText = "";

      function checkSelections() {
        if (!submitButton) return;
        // Check if both font and custom text are selected
        if ((selectedFont || selectedColor) && customText.trim() !== "") {
          submitButton.disabled = false;
        } else {
          submitButton.disabled = true;
        }
      }

      colorSwatches.forEach((swatch) => {
        swatch.addEventListener("click", function () {
          selectedColor = this.dataset.color;
          document.getElementById("selected-color").textContent = selectedColor;
          checkSelections();
        });
      });

      fontInputs.forEach((input) => {
        input.addEventListener("change", function () {
          selectedFont = this.value; // Use input.value to get the selected font
          document.getElementById("selected-font").textContent = selectedFont;
          checkSelections();
        });
      });

      customTextInput?.addEventListener("input", function () {
        customText = this.value;
        checkSelections();
      });

      checkSelections();
    }

    updateFonts() {
      const fontFamilyLabel = document.getElementById("selected-font"); // Selected font label
      const fonts = document.querySelectorAll('.color-swatches input[type="radio"]'); // Select all radio inputs
      const overlayText = document.getElementById("overlay-text"); // The text element you want to style

      // Function to set the font family
      function setFontFamily(fontInput) {
        selectedFont = fontInput.getAttribute("data-font"); // Get the selected font

        // Update the font label
        if (fontFamilyLabel) {
          fontFamilyLabel.textContent = selectedFont;
        }

        // Update the font on the product image (or another target element)
        if (overlayText) {
          overlayText.style.fontFamily = selectedFont;
          overlayText.style.fontWeight = 600;
        }

        // Remove 'active' class from all labels
        fonts.forEach((input) => {
          input.parentElement.classList.remove("active");
        });

        // Add 'active' class to the selected label
        fontInput.parentElement.classList.add("active");
      }

      // Add event listener to each swatch (use change instead of click for radio inputs)
      fonts.forEach((swatch) => {
        swatch.addEventListener("change", function () {
          setFontFamily(this);
        });
      });
    }

    init() {
      this.cartType = this.hasAttribute("data-ajax-cart") ? "ajax" : "page";
      if (!document.body.classList.contains("template-cart") || this.hasAttribute("data-force-form")) {
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.ADD_TO_CART = new Event("add-to-cart");
      }
      if (document.body.classList.contains("touchevents")) {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener("touchend", (e) => {
            //submitButton.click();
          });
        }
      }
    }

    async onSubmitHandler(e) {
      e.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton?.classList.add("working");

      let formData = new URLSearchParams(new FormData(this.form));

      const customText = document.getElementById("personalisation-text-input")?.value || "";
      const selectedColor = document.getElementById("selected-color")?.textContent || "";
      const selectedFont = document.getElementById("selected-font")?.textContent || "";

      formData.append("properties[Personalisation Text]", customText);
      formData.append("properties[Personalisation Color]", selectedColor);
      formData.append("properties[Personalisation Font]", selectedFont);

      const body = formData.toString();

      const lookupTable = {
        Gold: "46317670203579",
        Silver: "46317670236347",
        Blind: "46317670269115",
        Baskerville: "46317672038587",
        Optima: "46317672071355",
        "Gill Sans": "46317672104123",
      };

      let personalisationVariantId = "";

      // Check if the product has the "Personalisation" tag
      let tags = [];
      try {
        tags = JSON.parse(document.querySelector("[data-product-tags]")?.innerText || "[]");
      } catch (e) {}

      if (tags.includes("Paper Personalisation") || tags.includes("Pen Personalisation")) {
        personalisationVariantId = lookupTable[selectedFont] || lookupTable[selectedColor];
      }

      try {
        const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
          body,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest",
          },
          method: "POST",
        });
        const result = await response.json();

        if (result.status === 422) {
          let alert = document.createElement("span");
          alert.className = "alert alert--error";
          alert.innerHTML = typeof result.description === "string" ? result.description : result.message;
          if (this.cartType === "page") {
            const errorContainer = document.getElementById("product-page-form-error-cart-alert");
            if (errorContainer) errorContainer.remove();
            alert.id = "product-page-form-error-cart-alert";
            alert.style.marginTop = "1em";
            alert.style.marginBottom = "0";
            return;
          }
          await fetch("?section_id=helper-cart");
        } else {
          if (this.cartType === "page") {
            document.location.href = KROWN.settings.routes.cart_url;
            return;
          } else {
            await fetch("?section_id=helper-cart");
          }
        }

        const cartResponse = await fetch("?section_id=helper-cart");
        const cartText = await cartResponse.text();
        const sectionInnerHTML = new DOMParser().parseFromString(cartText, "text/html");
        const cartFormInnerHTML = sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

        const cartItems = document.getElementById("AjaxCartForm");
        if (cartItems) {
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();
          document.getElementById("AjaxCartSubtotal").innerHTML = cartSubtotalInnerHTML;

          document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
            elm.textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent;
          });
          document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
            elm.textContent = document.querySelector("#AjaxCartForm [data-cart-total]").textContent;
          });
        }

        this.dispatchEvent(this.ADD_TO_CART);

        const screenReaderInfo = document.getElementById("screen-reader-info");
        if (screenReaderInfo) {
          screenReaderInfo.innerText = `${KROWN.settings.locales.cart_announcement}`;
          setTimeout(() => {
            screenReaderInfo.innerText = "";
          }, 1000);
        }

        if (personalisationVariantId) {
          const personalisationProduct = { id: personalisationVariantId.toString(), quantity: 1 };

          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(personalisationProduct),
          });

          window.refreshCart();
          const drawer = document.getElementById("personalisation-sidebar");
          if (drawer) {
            drawer.hide(); // Assuming 'hide' is the method to close the sidebar drawer
          }
        }
      } catch (error) {
        console.error("Error applying personalisation charge:", error);
      } finally {
        submitButton?.classList.remove("working");
      }
    }

    _serializeForm(form) {
      let arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1) return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value));
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) return;
        arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
      });
      return arr.join("&");
    }
  }

  if (typeof customElements.get("product-form") == "undefined") {
    customElements.define("product-form", ProductForm);
  }
}

/* ---
	Product Recommendations
--- */

if (typeof ProductRecommendations !== "function") {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const SUCCESS = new Event("product-recommendations-loaded");
      const FAIL = new Event("product-recommendations-error");

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const innerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("product-recommendations");

            if (innerHTML && innerHTML.querySelectorAll("[data-js-product-item]").length > 0) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll("form").forEach((elm) => {
                if (elm.querySelector("template")) {
                  elm.append(elm.querySelector("template").content.cloneNode(true));
                }
              });
              this.dispatchEvent(SUCCESS);
            } else {
              this.dispatchEvent(FAIL);
            }
          })
          .catch((e) => {
            this.dispatchEvent(FAIL);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: `0px 0px 400px 0px` }).observe(this);
    }
  }

  if (typeof customElements.get("product-recommendations") == "undefined") {
    customElements.define("product-recommendations", ProductRecommendations);
  }
}

/* ---
	Gift card recipent
--- */

if (typeof GiftCardRecipient !== "function") {
  class GiftCardRecipient extends HTMLElement {
    constructor() {
      super();

      const properties = Array.from(this.querySelectorAll('[name*="properties"]'));
      const checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";

      this.recipientCheckbox = properties.find((input) => input.name === checkboxPropertyName);
      this.recipientOtherProperties = properties.filter((input) => input.name !== checkboxPropertyName);
      this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields");

      if (this.recipientCheckbox) {
        this.recipientCheckbox.addEventListener("change", this.synchronizeProperties.bind(this));
      }
      this.synchronizeProperties();
    }

    synchronizeProperties() {
      this.recipientOtherProperties.forEach((property) => (property.disabled = !this.recipientCheckbox.checked));
      this.recipientFieldsContainer.classList.toggle("hide", !this.recipientCheckbox.checked);
    }
  }

  if (typeof customElements.get("gift-card-recipient") == "undefined") {
    customElements.define("gift-card-recipient", GiftCardRecipient);
  }
}

/* ---
	Sticky Add to Cart
--- */

if (typeof StickyAddToCart !== "function") {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();

      const productPage = document.getElementById(this.dataset.id);
      this.hasAttribute("data-append-to")
        ? document.querySelector(this.dataset.appendTo).appendChild(this)
        : document.body.appendChild(this);

      const productButton = productPage.querySelector("[data-js-product-add-to-cart]");
      const stickyBar = this;

      function toggleStickyBarOnScroll() {
        const rect = productButton.getBoundingClientRect();
        const isInViewport =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom - 80 <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        const isMobile = window.innerWidth < 728;

        if ((!isMobile && rect.top < 0) || (isMobile && !isInViewport)) {
          stickyBar.classList.add("visible");
        } else {
          stickyBar.classList.remove("visible");
        }
      }
      window.addEventListener("scroll", toggleStickyBarOnScroll);
      toggleStickyBarOnScroll();

      if (this.hasAttribute("data-single")) {
        const stickyButton = this.querySelector("button[data-js-atc]");

        stickyButton.addEventListener("click", () => {
          productButton.click();
          stickyButton.classList.add("working");
        });

        new MutationObserver(() => {
          if (productButton.classList.contains("working")) {
            stickyButton.classList.add("working");
          } else {
            stickyButton.classList.remove("working");
          }
        }).observe(productButton, {
          attributes: true,
          childList: false,
          subtree: false,
        });
      } else {
        this.querySelector("button[data-js-choose]").addEventListener("click", () => {
          productButton.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      }
    }
  }

  if (typeof customElements.get("sticky-add-to-cart") == "undefined") {
    customElements.define("sticky-add-to-cart", StickyAddToCart);
  }
}
